import React, { useMemo, useState } from "react";
import { DEPARTEMENT_NAMES, DEPARTEMENT_TO_ZONE } from "../lib/climate";
import { Search } from "lucide-react";
import { Input } from "./ui/input";

export default function DepartmentSelector({ value, onSelect }) {
  const [query, setQuery] = useState("");

  const sortedDepts = useMemo(() => {
    return Object.keys(DEPARTEMENT_NAMES)
      .sort((a, b) => {
        // 2A, 2B between 19 and 21
        const order = (k) =>
          k === "2A" ? 20.0 : k === "2B" ? 20.5 : parseInt(k, 10);
        return order(a) - order(b);
      });
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return sortedDepts;
    return sortedDepts.filter(
      (code) =>
        code.toLowerCase().includes(q) ||
        DEPARTEMENT_NAMES[code].toLowerCase().includes(q)
    );
  }, [query, sortedDepts]);

  return (
    <div className="pac-card p-4" data-testid="department-selector">
      <div className="flex items-center justify-between gap-3 mb-3">
        <h3 className="font-display text-lg font-semibold text-slate-900">
          Sélection par département
        </h3>
        <span className="pac-pill bg-blue-50 text-blue-700">
          {filtered.length} dépts
        </span>
      </div>
      <div className="relative mb-3">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input
          type="text"
          placeholder="Rechercher (n° ou nom)..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="pl-9 h-10 bg-slate-50 border-slate-200"
          data-testid="department-search-input"
        />
      </div>
      <div className="max-h-72 overflow-auto rounded-lg border border-slate-100 divide-y divide-slate-100">
        {filtered.length === 0 && (
          <p className="p-3 text-sm text-slate-500">Aucun département trouvé.</p>
        )}
        {filtered.map((code) => {
          const zone = DEPARTEMENT_TO_ZONE[code];
          const isSelected = value === code;
          return (
            <button
              key={code}
              type="button"
              onClick={() => onSelect?.(code, zone)}
              data-testid={`dept-option-${code}`}
              className={`w-full flex items-center justify-between gap-3 px-3 py-2 text-left text-sm transition-colors ${
                isSelected ? "bg-blue-50 text-blue-900" : "hover:bg-slate-50 text-slate-700"
              }`}
            >
              <span className="flex items-center gap-3 min-w-0">
                <span className="font-mono-data font-semibold text-slate-900 w-8 text-right">
                  {code}
                </span>
                <span className="truncate">{DEPARTEMENT_NAMES[code]}</span>
              </span>
              <span className="pac-pill bg-slate-100 text-slate-700">
                Zone {zone}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
